// Build58 AlbumDetailScreen SVG fallback. Native Skia / extracted palette remain separate.
const PROGRESS = [
  0, 0.08, 0.16, 0.205, 0.28, 0.382, 0.46, 0.529, 0.6, 0.676, 0.74, 0.823, 0.882, 0.927, 0.97, 1,
];
export function albumHeroFade(height, dark = false, brightArtworkFactor = 0) {
  const scale = height > 12 ? (height - 12) / height : 1;
  const start = (dark ? 0.36 : 0.34) * scale;
  const end = 1 - (1 - scale) * 0.5;
  return [
    { offset: 0, opacity: 0 },
    ...PROGRESS.map((progress) => {
      const base = 0.01 + 0.99 * (1 - Math.pow(1 - Math.pow(progress, 2.56), 1.24));
      const boost = dark
        ? Math.max(0, Math.min(1, brightArtworkFactor)) *
          0.27 *
          Math.pow(Math.max(0, Math.min(1, (progress - 0.3) / 0.6)), 1.1) *
          (1 - base)
        : 0;
      return {
        offset: start + (end - start) * progress,
        opacity: Math.max(0, Math.min(1, base + boost)),
      };
    }),
    ...(end < 1 ? [{ offset: 1, opacity: 1 }] : []),
  ];
}
